import { colours } from "@shared/ui.design-system";
import { CompareIcon } from "@shared/ui.icons";
import { Ribbon } from "@shared/ui.primitives";
import { clsx } from "clsx";

import * as styles from "./ProductComparisonRibbon.css";

export const ProductComparisonRibbon = () => {
  return (
    <a
      href="#product-comparison"
      className={clsx("comparison-ribbon", styles.container)}
    >
      <div className={styles.ribbonWrapper}>
        <Ribbon colour="white" variant="rounded" size="medium">
          <div className={styles.ribbonContentWrapper}>
            <CompareIcon color={colours.primary.dark} width={16} height={16} />{" "}
            Compare Product
          </div>
        </Ribbon>
      </div>
    </a>
  );
};
